import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { Button, message, Spin } from "antd";
import styled from "styled-components";
import { FormattedMessage, useIntl } from "react-intl";

import AppDetailForm from "../components/AppSetting/AppDetailForm";
import AppInfoForm from "../components/AppSetting/AppInfoForm";
import Axios from "../util/request";

function AppSetting(props) {
  const [defaultValue, setDefalutValue] = useState({
    appName: "",
    client_id: "",
    client_secret: "",
    description: "",
    homepage: "",
    redirect_uri: []
  });
  const [spin, setSpin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isFormValueChanged, setIsFormValueChanged] = useState(false);
  const [isUnmouted, setIsUnmouted] = useState(false);

  const FormRef = useRef(null);
  const InfoFormRef = useRef(null);

  const { id } = props.match.params;

  const Intl = useIntl();

  const saveAllChanges = () => {
    FormRef.current.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const updateAppData = { ...defaultValue, ...values };
        InfoFormRef.current.validateFieldsAndScroll((err, values) => {
          const newValues = { redirect_uri: [values.redirect_uri] };
          console.log(values.redirect_uri);
          if (!err) {
            if (isFormValueChanged) {
              setLoading(true);
              Axios.put(`/api/v1/oauthapp/${id}`, {
                ...updateAppData,
                ...newValues
              })
                .then(res => {
                  props.history.push("/manage");
                  if (isUnmouted) {
                    setLoading(false);
                  }
                })
                .catch(err => {
                  message.error(Intl.formatMessage({ id: "message_saveFailed" }));
                })
                .finally(() => {});
            } else {
              props.history.push("/manage");
            }
          } else {
            setLoading(false);
          }
        });
      } else {
        setLoading(false);
      }
    });
  };
  // 重置 Client Secret
  const handleResetSecret = () => {
    Axios.put(`/api/v1/oauthapp/${id}/secret/reset`)
      .then(res => {
        setDefalutValue({
          ...defaultValue,
          client_secret: res.data
        });
        return true;
      })
      .catch(err => {
        message.error(Intl.formatMessage({ id: "message_resetFailed" }));
        return false;
      });
  };
  useEffect(() => {
    Axios.get(`/api/v1/oauthapp/${id}`)
      .then(res => {
        setDefalutValue(defaultValue => ({ ...defaultValue, ...res.data }));
      })
      .catch(err => {})
      .finally(() => {
        setSpin(false);
        setIsFormValueChanged(false);
      });
    return () => {
      setIsUnmouted(true);
    };
  }, []);
  return (
    <AppSettingWrapper>
      <Container>
        <BackButton
          onClick={saveAllChanges}
          loading={loading}
          type={isFormValueChanged ? "primary" : null}
        >
          <FormattedMessage id={isFormValueChanged ? "appSetting_save" : "appSetting_back"} />
        </BackButton>
        <Main>
          <AppInfoForm
            customstyle={AppInfoFormStyle}
            handleResetSecret={handleResetSecret}
            ref={InfoFormRef}
            defaultValue={defaultValue}
            handleChanged={() => {
              setIsFormValueChanged(true);
            }}
          />
          <AppDetailForm
            customstyle={AppCustomFormStyle}
            defaultValue={defaultValue}
            ref={FormRef}
            handleChanged={() => {
              setIsFormValueChanged(true);
            }}
          />
          {spin ? (
            <SpinWrapper>
              <CustomSpin size="large" />
            </SpinWrapper>
          ) : null}
        </Main>
      </Container>
    </AppSettingWrapper>
  );
}

export default withRouter(AppSetting);

const AppSettingWrapper = styled.div`
  margin: 32px auto 0;
  max-width: 1080px;
`;

const Container = styled.div`
  @media (max-width: 1080px) {
    padding: 0 50px;
  }
`;

const Main = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  color: rgba(0, 0, 0, 0.65);
  @media (max-width: 1080px) {
    flex-wrap: wrap;
  }
`;

const AppInfoFormStyle = `
  flex: 1 1 664px;
  background: #ffffff;
  border-radius: 4px;
  padding: 0;
`;

const AppCustomFormStyle = `
  margin-left: 40px !important;
  flex: 1 1 446px;
  background: #ffffff;
  border-radius: 4px;
  padding: 0;
  @media (max-width: 1080px) {
    margin: 72px 0 0 0 !important;
  }
`;

const BackButton = styled(Button)`
  font-size: 14px;
  color: ${props => (props.type === "primary" ? "#fff" : "rgba(0, 0, 0, 0.65)")};
  text-align: left;
  padding: 0 16px !important;
  & > i {
    padding-right: 5px;
  }
`;

const SpinWrapper = styled.div`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.5);
`;

const CustomSpin = styled(Spin)`
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
